export default "__VITE_ASSET__V8Z5gKyY__"